
import { Vue, Options } from 'vue-class-component'
import * as bootstrap from 'bootstrap'

@Options({
  props: {
    payment_statistic: Object
  },
  name: 'PaymentPercentage',
  watch: {
    payment_statistic: {
      handler: 'loadDatas',
      deep: true
    }
  },
  data () {
    return {
      value: 0,
      changed: 0,
      tooltip: ''
    }
  },
  methods: {
    loadDatas: async function () {
      const data = this.payment_statistic
      this.value = (data.paid_total / (data.paid_total + data.unpaid_total)) * 100
      this.changed = 0
      // check if value is NaN
      if (isNaN(this.value)) {
        this.value = 0
      }

      const prevstat = this.payment_statistic.previous_statistic || null
      let prevvalue = 0
      if (prevstat) {
        prevvalue = (prevstat.paid_total / (prevstat.paid_total + prevstat.unpaid_total)) * 100
        if (isNaN(prevvalue)) {
          prevvalue = 0
        }
        if (prevvalue > 0) {
          this.changed = (this.value - prevvalue) / prevvalue * 100
          if (isNaN(this.changed)) {
            this.changed = 0
          }
        }
      }

      if (this.value > 0 && prevvalue == 0) {
        this.changed = 100
      }

      if (this.changed > 0) {
        this.tooltip = `Naik ${this.changed.toFixed(2)}% dari tahun ajaran sebelumnya (${prevvalue.toFixed(2)}%)`
      } else if (this.changed < 0) {
        this.tooltip = `Turun ${Math.abs(this.changed).toFixed(2)}% dari tahun ajaran sebelumnya (${prevvalue.toFixed(2)}%)`
      } else {
        this.tooltip = `Tidak berubah dari tahun ajaran sebelumnya (${prevvalue.toFixed(2)}%)`
      }
    }
  },
  mounted () {
    this.loadDatas()
  }
})
export default class PaymentPercentage extends Vue { }
